module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ci-hello')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4ac6a252"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 252
// module chunks = 4